export const MIN_RECEIPT_FILE_SIZE = 1;
export const MAX_RECEIPT_FILE_SIZE = 15 * 1024 * 1024;
export const RECEIPT_FILE_ACCEPT = 'application/pdf,.pdf';
export const RECEIPT_MIME_TYPE = 'application/pdf' as const;

export const RECEIPT_FILE_COUNT_ERROR = 'Можно прикрепить только один PDF-файл';
export const RECEIPT_FILE_TYPE_ERROR = 'Можно прикрепить только PDF-файл';
export const RECEIPT_FILE_SIZE_ERROR = 'Размер PDF должен быть от 1 байта до 15 МБ';
export const RECEIPT_FILE_READ_ERROR = 'Не удалось прочитать PDF-файл';
export const RECEIPT_UNSUITABLE_TITLE = 'Чек не прошёл проверку';
export const RECEIPT_UNSUITABLE_ERROR =
    'Прикрепите другой чек об оплате в формате PDF. Если уверены, что чек корректный, обратитесь в поддержку.';
export const RECEIPT_UNSUITABLE_WITH_TRACE_ERROR =
    'Прикрепите другой чек об оплате в формате PDF. Если уверены, что чек корректный, обратитесь в поддержку и сообщите код ошибки.';
